import React from 'react';
import { Hash, Database, Zap } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';

const pillars = [
  {
    icon: Hash,
    title: 'Ingénierie Inverse des Hashs',
    description: 'Nous analysons et détectons vos types de hash hérités (MD5, SHA-X, BCrypt, PBKDF2 ou formats propriétaires) pour les porter nativement dans Auth0. Vos utilisateurs conservent leurs mots de passe sans jamais s\'en apercevoir.',
    color: 'primary'
  },
  {
    icon: Database,
    title: 'Enrichissement Post-Migration',
    description: 'Nous ne déplaçons pas seulement des comptes, nous les augmentons. Injection automatique de app_metadata et de profils enrichis via vos sources de données internes (RH, CRM, ERP) durant le flux de transit.',
    color: 'secondary'
  },
  {
    icon: Zap,
    title: 'Migration Bulk sans coupure',
    description: 'Zéro dépendance au login utilisateur. Nous opérons une migration massive en arrière-plan. Le lundi matin, votre parc est 100% SaaS sans qu\'un seul utilisateur n\'ait eu à se reconnecter.',
    color: 'primary'
  }
];

export default function PillarsSection() {
  return (
    <section id="pillars" className="py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Les 3 Piliers de
            <span className="text-gradient-purple"> l'Invisibilité</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Une approche technique qui garantit une transition sans friction pour vos utilisateurs
          </p>
        </div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <Card 
                key={index}
                className="glass border-border/50 hover-lift group relative overflow-hidden"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <CardHeader className="relative">
                  <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl mb-4 ${
                    pillar.color === 'primary' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'
                  }`}>
                    <Icon className="w-7 h-7" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-semibold mb-2">
                    {pillar.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative">
                  <CardDescription className="text-muted-foreground leading-relaxed">
                    {pillar.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-muted-foreground">
            Une solution éprouvée pour les migrations critiques
          </p>
        </div>
      </div>
    </section>
  );
}
